import { FC, ChangeEvent } from 'react';
import isEqual from 'lodash-es/isEqual';
import { TeamChatTypes } from '@frontend/api-team-chat';
import { useTranslation } from '@frontend/i18n';
import { RadioField, useFormField } from '@frontend/design-system';
import { ATTACHMENT_FILTER_OPTIONS } from '../../../constants';
import { useKeywordSearchStore } from '../../../providers/keyword-search.provider/keyword-search.provider';
import { FilterChipPopover } from '../../common/filter-chip-popover/filter-chip-popover.component';

export const AttachmentFilter: FC = () => {
  const { t } = useTranslation('team-chat');
  const { attachmentType, setAttachmentType } = useKeywordSearchStore(['attachmentType', 'setAttachmentType']);

  const fieldProps = useFormField({ type: 'radio', value: attachmentType ?? '' }, [attachmentType]);

  const selectedOption = ATTACHMENT_FILTER_OPTIONS.find((opt) => opt.id === fieldProps.value);
  const displayValue = selectedOption ? t('Has: {{label}}', { label: selectedOption.label }) : t('Image/GIF');

  const onClear = () => {
    fieldProps.onChange({ target: { value: '' } } as ChangeEvent<HTMLInputElement>);
    setAttachmentType(null);
  };
  const onApply = () => setAttachmentType(fieldProps.value as TeamChatTypes.Attachment['type']);

  return (
    <>
      <FilterChipPopover
        value={displayValue}
        onClear={onClear}
        onApply={onApply}
        isClearDisabled={!attachmentType}
        isApplyDisabled={isEqual(fieldProps.value, attachmentType) || !fieldProps.value.length}
        shouldCloseOnClear={true}
      >
        <RadioField name={'Attachment'} {...fieldProps}>
          {ATTACHMENT_FILTER_OPTIONS.map((option) => (
            <RadioField.Radio value={option.id} key={option.id}>
              {option.label}
            </RadioField.Radio>
          ))}
        </RadioField>
      </FilterChipPopover>
    </>
  );
};
